import React from "react";
import Styles from "./styles/MessageCardStyle.module.css";
import {
  convertSimpleDateFormat
} from "../../utils";
import Style from "../../pages/dashboard/styles/CustomerList.module.css";
import calendarR from "../../assets/images/calendarRArw.svg";
import calendarL from "../../assets/images/calendarLArw.svg";
import NoOfNights from "../../assets/images/no_of_nights.svg";
import NoOfChildren from "../../assets/images/no_of_children.svg";
import NoOfAdults from "../../assets/images/no_of_adult.svg";
import ReservationStatus from "../../assets/images/reservation_status.svg";
import RoomNo from "../../assets/images/room_no.svg";

const CheckInCard = ({ data }) => {
  // const totalAmount = data?.billAmount;
  // const discountAmount = totalAmount * (data?.discountPercentage / 100);
  // const finalAmount = data?.payableAmount;

  return (
    <div className={Styles.container} style={{ border: "1px solid black" }}>
      {/* <div className={Styles.reservationInfoWrapper}>
        <p className={Styles.userName}>
           Grand Elite Hotel
        </p>
        <div className={Styles.flexContainer} style={{alignItems:'flex-start'}}>
          <div>
            <div>
              <p>3 NIGHTS</p>
            </div>
            <div>
              <p className={Styles.dateTime}>
                {data?.checkin_date ? formatDate(data?.checkin_date) : '23-Jan-2025'}{" "}
                &nbsp;
                {data?.checking_time ? convertToAMPM(data?.checking_time) : '11:00 AM'}
              </p>
            </div>
            <div>
              <p className={Styles.dateTime}>
                {data?.checkout_date ? formatDate(data?.checkout_date) : '26-Jan-2025'}{" "}
                &nbsp;
                {data?.checkout_time ? convertToAMPM(data?.checkout_time) : '11:00 AM'}
              </p>
            </div> 
            <div>
              <p>Room Number: 301</p>
            </div> 
          </div>
          <div>
            <div>
              <p>Special Preference/Comments:</p>
            </div>
            <div>
              <p>Non-smoking room</p>
            </div>
            <div>
              <p>Extra pillows requested</p>
            </div>
            <div>
              <p></p>
            </div>
            <div style={{marginTop:'25px'}}>
              <p>{'Loyalty Program:'}</p>
              <p>{'Platinum Member (Loyalty ID: PLAT45678)'}</p>
            </div>
          </div>
        </div>
        <div style={{marginTop:'15px'}}>
          <p className={Styles.userName}>Bill Summary</p>
          <p>
            {`Total Amount Before Discount: ₹ ${totalAmount || "0.00"}`}
          </p> 
          <p>
            {`Discount Applied: ₹ ${discountAmount || "0.00"}`}
          </p>
          <p>
            {`Final Bill Amount: ₹ ${finalAmount || "0.00"}`}
          </p>
          <p>
            Settlement Type: {data?.billRecivedFrom || "N.A"}
          </p>
        </div>
      </div> */}
      <div className={Style.labelWraper}>
        {data?.check_in && (
          <div className={Style.label}>
            <img className={Style.img} src={calendarL} alt="message" />
            {convertSimpleDateFormat(data?.check_in)}
          </div>
        )}
        {data?.check_out && (
          <div className={Style.label}>
            <img className={Style.img} src={calendarR} alt="message" />
            {convertSimpleDateFormat(data?.check_out)}
          </div>
        )}
        {data?.room_numbers && (
          <div className={Style.label}>
            <img
              className={Style.img}
              src={RoomNo}
              alt="room no"
              style={{ height: 15, width: 15 }}
            />
            {data?.room_numbers}
          </div>
        )}
        {data?.no_of_adults > 0 && (
          <div className={Style.label}>
            <img
              className={Style.img}
              src={NoOfAdults}
              alt="no. of adults"
              style={{ height: 15, width: 15 }}
            />
            {data?.no_of_adults}
          </div>
        )}
        {data?.no_of_children > 0 && (
          <div className={Style.label}>
            <img
              className={Style.img}
              src={NoOfChildren}
              alt="no. of children"
              style={{ height: 15, width: 15 }}
            />
            {data?.no_of_children}
          </div>
        )}
        {data?.no_of_nights > 0 && (
          <div className={Style.label}>
            <img
              className={Style.img}
              src={NoOfNights}
              alt="no. of nights"
              style={{ height: 15, width: 15 }}
            />
            {data?.no_of_nights}
          </div>
        )}
        {data?.reservation_status && (
          <div className={Style.label}>
            <img
              className={Style.img}
              src={ReservationStatus}
              alt="reservation status"
              style={{ height: 15, width: 15 }}
            />
            {data?.reservation_status}
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckInCard;
